<template>
    <rkm-form
        v-if="loaded"
        show-legend
    >
        <Paciente
            :data="{ additionals, form, model }"
            ref="Paciente"
        />

        <Tabs
            :data="{ additionals, form, model }"
            ref="Tabs"
        />
    </rkm-form>
</template>

<script>
// Components.
import Paciente from './components/paciente/Form'
import Tabs from './Tabs'

// Others.
import { mapActions } from 'vuex'
import { repository, error, object, stringCase, data } from '@/mixins'

export default {
    components: { Paciente, Tabs },
    created() {

        this.repositories = {
            altoCustoGerenciamentoProcesso: this.getConectaSusRepository('farmacia.altoCustoGerenciamentoProcesso'),
        }

        this.load()
    },
    data: () => ({
        additionals: null,
        form: null,
        model: null,
        loaded: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.altoCustoGerenciamentoProcesso.edit(this.id)
                : this.repositories.altoCustoGerenciamentoProcesso.create(this.pacienteId)

            request
                .then(({ data }) => {

                    this.setDates(data.model)

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.$emit('data-load', {
                        additionals: this.additionals,
                        form: this.form,
                        model: this.model,
                    })

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setDates(model) {

            model.solicitadoEm = this.getDateObject(model.solicitadoEm)

            model.itens.map(i => i.meses.map(mes => {

                if (mes.enviadoDrsEm) {

                    mes.enviadoDrsEm = this.getDateObject(mes.enviadoDrsEm)
                }

                if (mes.retiradoDrsEm) {

                    mes.retiradoDrsEm = this.getDateObject(mes.retiradoDrsEm)
                }

                if (mes.retiradoPacienteEm) {

                    mes.retiradoPacienteEm = this.getDateObject(mes.retiradoPacienteEm)
                }
            }))
        },
        save(continuarNaMesmaTela) {

            Promise.all([
                this.$refs.Paciente.validate(),
                this.$refs.Tabs.validate(),
            ])
                .then(([formPacienteValid, tabsValid]) => {

                    if (!formPacienteValid || !tabsValid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.altoCustoGerenciamentoProcesso.update(this.id, this.prepareData())
                        : this.repositories.altoCustoGerenciamentoProcesso.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            if (data.numeroRecebimento > 0) {

                                this.showSaveNotification(`
                                    Registro salvo com sucesso!<br>
                                    O número de recebimento é <strong>${data.numeroRecebimento}</strong>.
                                `)
                            }
                            else {

                                this.showSaveNotification()
                            }

                            this.$emit('save', { processo: data, continuarNaMesmaTela })
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const data = this.clone(this.model)

            data.pacienteId = this.pacienteId

            delete data.createdCentroCustoId
            delete data.numeroRecebimento

            this.formateDates(data, [
                'solicitadoEm',
            ])

            this.createIdKeysToObject(data, [
                'usuarioSolicitante',
                'cid',
            ])

            data.itens.map(item => {

                this.createIdKeysToObject(item, [
                    'material',
                ])

                item.meses.map(mes => {

                    this.formateDates(mes, [
                        'enviadoDrsEm',
                        'retiradoDrsEm',
                        'retiradoPacienteEm',
                    ])

                    this.createIdKeysToObject(mes, [
                        'usuarioAtendente',
                        'status',
                    ])

                    if (mes.enviadoDrsEm === '') {

                        mes.enviadoDrsEm = null
                    }

                    if (mes.retiradoDrsEm === '') {

                        mes.retiradoDrsEm = null
                    }

                    if (mes.retiradoPacienteEm === '') {

                        mes.retiradoPacienteEm = null
                    }
                })
            })

            data.devolucoesMedicamento = data.devolucoesMedicamento.filter(d => !d.id).map(d => ({
                devolvidoEm: d.devolvidoEm,
                materialId: d.material.id,
                quantidade: d.quantidade,
                lote: d.lote,
                dataFabricacao: d.dataFabricacao,
                dataValidade: d.dataValidade,
                laboratorio: d.laboratorio,
                motivo: d.motivo,
            }))

            return this.camelObjectKeysToSnakeRecursive(data)
        }
    },
    mixins: [repository, error, object, stringCase, data],
    props: {
        id: { type: Number, default: null },
        pacienteId: { type: Number, required: true },
    },
}
</script>